export const DATA_TOKENS = {
  page: 'bg-[#f5f7fb]',
  panel: 'bg-white',
  panelMuted: 'bg-[#fbfcfe]',
  softSurface: 'bg-[#fbfcfe]',
  topicSurface: 'bg-[#fbfcfe]',
  border: 'border-[#d7e3f1]',
  borderSoft: 'border-[#dbe4ee]',
  borderMuted: 'border-[#e2e8f0]',
  headerText: 'text-[#64748b]',
  mutedText: 'text-[#64748b]',
  secondaryText: 'text-[#475569]',
  foreground: 'text-[#0f172a]',
  accentText: 'text-[#1428a0]',
  dangerText: 'text-[#ef4444]',
  input: 'bg-white',
} as const

export const DATA_PILL_TONES = {
  success: 'bg-[#ecfdf5] text-[#047857] ring-1 ring-[#a7f3d0]',
  info: 'bg-[#eef4ff] text-[#1428a0] ring-1 ring-[#c8d7ff]',
  accent: 'bg-[#eef4ff] text-[#1d4ed8] ring-1 ring-[#c8d7ff]',
  neutral: 'bg-[#f5f7fa] text-[#516079] ring-1 ring-[#d7e3f1]',
  warning: 'border border-[#f59e0b]/25 bg-[#f59e0b]/10 text-[#b45309]',
  danger: 'border border-[#ef4444]/25 bg-[#ef4444]/10 text-[#b91c1c]',
  muted: 'border border-[#cbd5e1] bg-[#f8fafc] text-[#475569]',
  statusActive: 'border border-[#16a34a]/40 bg-[#22c55e]/15 text-[#15803d]',
  competitionLow: 'border border-[#22c55e]/25 bg-[#22c55e]/10 text-[#166534]',
  competitionMedium: 'border border-[#f59e0b]/25 bg-[#f59e0b]/10 text-[#b45309]',
  competitionHigh: 'border border-[#ef4444]/25 bg-[#ef4444]/10 text-[#b91c1c]',
} as const

export type DataPillTone = keyof typeof DATA_PILL_TONES

export const DATA_METRIC_COLORS = {
  positive: 'text-[#8b5cf6]',
  negative: 'text-[#f59e0b]',
  neutral: 'text-[#475569]',
} as const
